import axios from 'axios'
import { getProject } from '../components/Accounts/API'

export const SET_STORE = 'SET_STORE'
export const START_NEW_PROJECT = 'START_NEW_PROJECT'

const setStore = state => {
    return {
        type: SET_STORE,
        state
    }
}

export const startNewProject = () => {
    return {
        type: START_NEW_PROJECT
    }
}

export const getProjectState = uuid => {
    return async dispatch => {
        const response = await getProject(uuid)
        dispatch(setStore(response.state))
    }
}

export const getState = hash_input => {
    return dispatch => {
        axios.get('/retrieve-state/', { params: { hash: hash_input } }).then(response => {
            if (response.data) {
                dispatch(setStore(response.data))
            }
        })
    }
}

// utility
export const removeExtraneousState = state => {
    const { layers, mapSettings, parcels, screen } = state
    return { layers, mapSettings, parcels, screen }
}
